var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-alert',{staticClass:"alert",attrs:{"type":"success","closable":false,"effect":"dark"}},[_c('span',{staticClass:"span-senha"},[_vm._v(" "+_vm._s(_vm.mensagem)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }